import { Icon, Option, Select } from 'idea-react';
import { observer } from 'mobx-react';
import { Container, Image, Navbar } from 'react-bootstrap';

import { i18n, LanguageName } from '../model/Translation';
import userStore from '../model/User';
import { UserMenu } from './UserMenu';

export const MainNavigator = observer(() => {
    const { currentLanguage } = i18n;
    const { session } = userStore;

    return (
        <Navbar
            className="border-bottom"
            style={{ zIndex: 1030 }}
            bg="white"
            variant="light"
            sticky="top"
            expand="lg"
        >
            <Container fluid>
                <Navbar.Brand
                    className="d-flex align-items-center gap-2"
                    href="."
                >
                    <Icon className="text-primary" name="robot" size={2} />
                    {document.title}
                </Navbar.Brand>

                <div className="d-flex align-items-center gap-3">
                    <Select
                        value={currentLanguage}
                        onChange={key =>
                            i18n.loadLanguages(key as typeof currentLanguage)
                        }
                    >
                        {Object.entries(LanguageName).map(([key, name]) => (
                            <Option key={key} value={key}>
                                {name}
                            </Option>
                        ))}
                    </Select>

                    {session && <UserMenu {...session} />}
                </div>
            </Container>
        </Navbar>
    );
});
